export const inventoryEn = {
  "pos.supplierReturn.title": "Supplier returns",
  "pos.supplierReturn.help": "Return selected quantities from their original receipt and cost layer. Purchase commitments and payable credits stay separate.",
  "pos.supplierReturn.quantity": "Return quantity · {name}",
  "pos.supplierReturn.available": "Original receipt: {received} · Available from this cost layer: {available} · Cost per stock unit: {cost}",
  "pos.supplierReturn.reason": "Reason for return or correction",
  "pos.supplierReturn.reference": "Supplier return / correction reference",
  "pos.supplierReturn.date": "Return / correction date",
  "pos.supplierReturn.review": "Review supplier return",
  "pos.supplierReturn.undo": "Review undo",
  "pos.supplierReturn.undoHelp": "This correction restores every allocation from the selected supplier return at its original cost. It does not receive another delivery or change the purchase commitment.",
  "pos.supplierReturn.ack": "I verified the actual goods, original receipt costs and supplier reference. This changes stock only.",
  "pos.supplierReturn.confirm": "Confirm reviewed stock change",
  "pos.supplierReturn.retry": "Retry the same request",
  "pos.supplierReturn.unknown": "The result is not confirmed. Keep this review and retry the same request, or reload the receipt history to check the recorded outcome.",
  "pos.supplierReturn.invalid": "Enter a reason, supplier reference, date and at least one positive exact quantity.",
  "pos.supplierReturn.cost": "Stock cost of this change",
  "pos.supplierReturn.beforeAfter": "On hand: {before} → {after}",
  "pos.supplierReturn.posted": "Stock change recorded",
  "pos.supplierReturn.view": "View recorded change",
  "pos.supplierReturn.history": "Supplier return history",
  "pos.supplierReturn.empty": "No supplier returns for this receipt.",
  "pos.supplierReturn.new": "New supplier return",
  "pos.supplierReturn.allHistory": "View all stock history",
  "pos.supplierReturn.back": "Back to stock receiving",
  "pos.supplierReturn.loadAgain": "Reload receipt history",
  "pos.supplierReturn.undoSelection": "Undo selected return",
  "pos.stockOps.supplier_return": "Supplier return",
  "pos.stockOps.supplier_return_undo": "Undo supplier return",
  "pos.inventory.receiptTitle": "{status} receipt · {reference}",
  "pos.inventory.addVariant": "Add {name}",
  "pos.inventory.archivedSuffix": " (archived)",
  "pos.inventory.postedReceiptNote": "Posted {at}. Stock movements and this receipt are immutable.",
  "pos.inventory.stockReceiving": "Stock receiving",
  "pos.inventory.receiveVendorDeliveriesIntoStockLocationsAnd": "Receive vendor deliveries into stock locations and review quantities on hand.",
  "pos.inventory.newReceipt": "New receipt",
  "pos.inventory.stockLocationsAreIndependentOfSalesOutlets": "Stock locations are independent of sales outlets and Jonas stock areas. On-hand quantities include native receipts, openings, corrections, sales and returns.",
  "pos.inventory.inventory": "Inventory",
  "pos.inventory.onHand": "On hand",
  "pos.inventory.locations": "Locations",
  "pos.inventory.receiving": "Receiving",
  "pos.inventory.stockLocation": "Stock location",
  "pos.inventory.chooseALocation": "Choose a location",
  "pos.inventory.inactive": " (inactive)",
  "pos.inventory.searchOnhandItems": "Search on-hand items",
  "pos.inventory.chooseALocationToViewPostedStock": "Choose a location to view posted stock.",
  "pos.inventory.onhandQuantities": "On-hand quantities",
  "pos.inventory.itemVariant": "Item / variant",
  "pos.inventory.sKU": "SKU",
  "pos.inventory.quantity": "Quantity",
  "pos.inventory.noPostedStockAtThisLocation": "No posted stock at this location.",
  "pos.inventory.first200ItemsShownNarrowTheSearch": "First 200 items shown. Narrow the search to find other stock.",
  "pos.inventory.stockReceipts": "Stock receipts",
  "pos.inventory.received": "Received",
  "pos.inventory.vendorReference": "Vendor / reference",
  "pos.inventory.location": "Location",
  "pos.inventory.status": "Status",
  "pos.inventory.review": "Review",
  "pos.inventory.openReceipt": "Open receipt",
  "pos.inventory.latest200ReceiptsShown": "Latest 200 receipts shown.",
  "pos.inventory.noNativeReceiptsYet": "No native receipts yet",
  "pos.inventory.createADraftWhenAVendorDelivery": "Create a draft when a vendor delivery arrives.",
  "pos.inventory.stockLocationCreated": "Stock location created.",
  "pos.inventory.stockLocations": "Stock locations",
  "pos.inventory.useReceivingLocationsSuchAsTheStoreroom": "Use receiving locations such as the storeroom or pro shop stockroom.",
  "pos.inventory.locationCode": "Location code",
  "pos.inventory.locationName": "Location name",
  "pos.inventory.addLocation": "Add location",
  "pos.inventory.name": "Name",
  "pos.inventory.code": "Code",
  "pos.inventory.action": "Action",
  "pos.inventory.active": "Active",
  "pos.inventory.inactive2": "Inactive",
  "pos.inventory.stockLocationUpdated": "Stock location updated.",
  "pos.inventory.deactivate": "Deactivate",
  "pos.inventory.activate": "Activate",
  "pos.inventory.backToReceipts": "Back to receipts",
  "pos.inventory.reloadSavedReceipt": "Reload saved receipt",
  "pos.inventory.posted": "Posted",
  "pos.inventory.draft": "Draft",
  "pos.inventory.newReceivingDraft": "New receiving draft",
  "pos.inventory.1DeliveryDetails2VariantQuantitiesAnd": "1. Delivery details → 2. Variant quantities and costs → 3. Save and review → 4. Manager posts",
  "pos.inventory.deliveryDetails": "Delivery details",
  "pos.inventory.chooseLocation": "Choose location",
  "pos.inventory.receivedDate": "Received date",
  "pos.inventory.findVendor": "Find vendor",
  "pos.inventory.vendor": "Vendor",
  "pos.inventory.chooseVendor": "Choose vendor",
  "pos.inventory.supplierDeliveryInvoiceReference": "Supplier delivery / invoice reference",
  "pos.inventory.receivingNotes": "Receiving notes",
  "pos.inventory.receivedVariants": "Received variants",
  "pos.inventory.quantityUsesTheVariantsStockUnitUnit": "Quantity uses the variant’s stock unit. Unit cost is in the club currency per stock unit, with up to four decimal places. Archived catalogue items can be received without activating sales.",
  "pos.inventory.findItemVariantOrSKU": "Find item, variant or SKU",
  "pos.inventory.typeAtLeastTwoCharactersSearchIncludes": "Type at least two characters. Search includes archived items.",
  "pos.inventory.searching": "Searching…",
  "pos.inventory.add": "Add",
  "pos.inventory.narrowTheSearchForMoreResults": "Narrow the search for more results.",
  "pos.inventory.remove": "Remove",
  "pos.inventory.saving": "Saving…",
  "pos.inventory.saveDraft": "Save draft",
  "pos.inventory.reviewAndPost": "Review and post",
  "pos.inventory.postingAddsTheseQuantitiesToNativeOnhand": "Posting adds these quantities to native on-hand stock. Posted receipts are permanent; cancellation and reversal are not available in this release.",
  "pos.inventory.saveTheChangesBeforeReviewingAndPosting": "Save the changes before reviewing and posting.",
  "pos.inventory.confirmTheSavedVendorLocationReceivedDate": "Confirm the saved vendor, location, received date, quantities and unit costs above. This does not create a payable bill or a general ledger entry.",
  "pos.inventory.posting": "Posting…",
  "pos.inventory.confirmAndPostReceipt": "Confirm and post receipt",
  "pos.inventory.keepAsDraft": "Keep as draft",
  "pos.inventory.reviewSavedReceiptForPosting": "Review saved receipt for posting",
  "pos.inventory.aStaffMemberWithPOSManagementPermission": "A staff member with POS management permission can post this saved receipt.",
  "pos.inventory.stockMovementsAndThisReceiptAreImmutable": ". Stock movements and this receipt are immutable.",
  "pos.inventory.quantityLine": "Quantity, line {line}",
  "pos.inventory.unitCostLine": "Unit cost, line {line}",
  "pos.inventory.removeLine": "Remove line {line}",
  "pos.inventory.stockOperationsLink": "Corrections and transfers",
  "pos.stockOps.title": "Stock operations",
  "pos.stockOps.detailTitle": "Stock operation details",
  "pos.stockOps.subtitle": "Review immutable stock corrections, transfers, and receipt reversals.",
  "pos.stockOps.scopeNote": "Zero stock here does not represent Jonas opening stock. These operations do not change prices, sales printing, payables, or the general ledger.",
  "pos.stockOps.readOnlyNote": "You can review operation and movement history. POS management permission is required to preview or post a stock operation.",
  "pos.stockOps.newOperation": "New stock operation",
  "pos.stockOps.steps": "1. Enter the reason and quantities → 2. Review the before and after quantities → 3. Acknowledge and post.",
  "pos.stockOps.details": "Operation details",
  "pos.stockOps.operationType": "Operation type",
  "pos.stockOps.adjustment": "Adjustment",
  "pos.stockOps.transfer": "Transfer",
  "pos.stockOps.receiptReversal": "Receipt reversal",
  "pos.stockOps.stockLocation": "Stock location",
  "pos.stockOps.sourceLocation": "Source location",
  "pos.stockOps.destinationLocation": "Destination location",
  "pos.stockOps.chooseLocation": "Choose a location",
  "pos.stockOps.effectiveDate": "Effective date",
  "pos.stockOps.postedReceipt": "Posted receipt",
  "pos.stockOps.choosePostedReceipt": "Choose a posted receipt",
  "pos.stockOps.receiptIdLookup": "Receipt ID lookup",
  "pos.stockOps.receiptIdHint": "Select a recent receipt or paste its UUID to look up an older receipt.",
  "pos.stockOps.lookingUpReceipt": "Looking up receipt…",
  "pos.stockOps.receiptFound": "Posted receipt {reference} at {location}.",
  "pos.stockOps.receiptMustBePosted": "This receipt is not posted and cannot be reversed.",
  "pos.stockOps.findVariant": "Find item, variant, or SKU",
  "pos.stockOps.variantHint": "Type at least two characters to search. Archived catalogue items remain available.",
  "pos.stockOps.addVariant": "Add {name}",
  "pos.stockOps.narrowSearch": "Narrow the search to find more results.",
  "pos.stockOps.lines": "Variants and quantities",
  "pos.stockOps.quantityLine": "Quantity, line {line}",
  "pos.stockOps.signedQuantityHint": "Enter a signed adjustment. Positive adds stock; negative removes stock.",
  "pos.stockOps.positiveQuantityHint": "Enter a positive quantity to transfer.",
  "pos.stockOps.removeLine": "Remove line {line}",
  "pos.stockOps.reversalLinesNote": "The reversal uses the exact lines from the posted receipt.",
  "pos.stockOps.reason": "Reason",
  "pos.stockOps.previewing": "Building preview…",
  "pos.stockOps.previewAction": "Preview operation",
  "pos.stockOps.previewTitle": "Review stock impact",
  "pos.stockOps.previewSummary": "{kind} effective {date}",
  "pos.stockOps.previewLines": "Stock operation quantities",
  "pos.stockOps.change": "Change",
  "pos.stockOps.before": "Before",
  "pos.stockOps.after": "After",
  "pos.stockOps.acknowledge": "I reviewed the locations and quantities above and want to post this immutable operation.",
  "pos.stockOps.immutableNotice": "Posted stock operations and their movements are permanent and cannot be edited or deleted.",
  "pos.stockOps.posting": "Posting…",
  "pos.stockOps.postOperation": "Post stock operation",
  "pos.stockOps.stalePreview": "Stock changed after this preview. Load a fresh preview before posting.",
  "pos.stockOps.reloadPreview": "Reload preview",
  "pos.stockOps.postedTitle": "Stock operation posted",
  "pos.stockOps.postedSummary": "Operation {id} posted at {at}.",
  "pos.stockOps.viewPostedOperation": "View posted operation",
  "pos.stockOps.startNewOperation": "Start new stock operation",
  "pos.stockOps.historyTitle": "Stock operation history",
  "pos.stockOps.action": "Action",
  "pos.stockOps.viewDetails": "View details",
  "pos.stockOps.loadingMore": "Loading…",
  "pos.stockOps.loadMore": "Load more",
  "pos.stockOps.emptyHistory": "No stock operations yet",
  "pos.stockOps.emptyHistoryHelp": "Posted corrections and transfers will appear here.",
  "pos.stockOps.movementsTitle": "Stock movement history",
  "pos.stockOps.filterLocation": "Filter by location",
  "pos.stockOps.allLocations": "All locations",
  "pos.stockOps.date": "Date",
  "pos.stockOps.emptyMovements": "No stock movements yet.",
  "pos.stockOps.backToHistory": "Back to stock operations",
  "pos.stockOps.backToInventory": "Back to inventory",
  "pos.stockOps.detailMetadata": "Operation {id} · effective {date} · posted {at}",
  "pos.stockOps.receipt": "Receipt",
  "pos.stockOps.opening": "Opening balance",
  "pos.stockOps.sale": "Sale deduction",
  "pos.stockOps.saleReturn": "Physical sale return",
} as const;
export type InventoryMessages = typeof inventoryEn;
